import React from "react";
import { Link } from "react-router-dom";
import CardReport from "../../../molecules/card/cardReport";

const Screen = ({ data }) => {
  const role = localStorage.getItem("role");
  return (
    <div className="h-screen py-3 mr-[40px]">
      <section className="border-y-2 py-5">
        <div className="flex">
          <div className="w-[80%]">
            <h1 className="font-bold text-center text-xl mb-4 pl-[14rem]">
              Financial Report
            </h1>
          </div>
          {role === "business" && (
            <div className="w-[20%] flex justify-end items-center">
              <p className="mr-2">Add: </p>
              <Link
                to="/business/dashboard/report/create"
                className="border-2 rounded-lg p-2 font2 shadow-[0_15px_12px_-12px_rgba(0,0,0,0.3)]"
              >
                Money Report +
              </Link>
            </div>
          )}
        </div>
        <div className="flex w-full justify-center gap-2 mt-6">
          <div className="w-4/12 text-center font-bold text-[#E88E08] border-2 h-auto rounded-2xl">
            <div className="mt-2 text-xl">Asset</div>
            <div className="text-2xl my-5">Rp. 1.000.000</div>
          </div>
          <div className="w-4/12 text-center font-bold text-[#074A87] border-2 h-auto rounded-2xl">
            <div className="mt-2 text-xl">Liabilitas</div>
            <div className="text-2xl my-5">-</div>
          </div>
          <div className="w-4/12 text-center font-bold text-[#305C20] border-2 h-auto rounded-2xl">
            <div className="mt-2 text-xl">Current Modal</div>
            <div className="text-2xl my-5">-</div>
          </div>
        </div>
        <div className="flex justify-center">
          <button className="bg-whiter rounded-md shadow-md font-bold py-1 px-3 mt-4">
            Download PDF
          </button>
        </div>
      </section>
      <section>
        <div className="text-center font-bold my-6">Latest News</div>
        <div className="flex justify-around gap-x-5">
          <div className="font-bold text-darker w-4/12">
            <div className="text-center bg-[#EAC9D7] py-2">Newest</div>
            <CardReport />
          </div>
          <div className="font-bold text-darker w-4/12">
            <div className="text-center bg-[#EAC9D7] py-2">Last Week</div>
            <CardReport />
          </div>
          <div className="font-bold text-darker  w-4/12 ">
            <div className="text-center bg-[#EAC9D7] py-2">Oldest</div>
            <CardReport />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Screen;
